import { HOST_ICON_MAP } from '@cynteka/ui-kit';

import { IconClip } from './icons/clip.component';
import { IconSend } from './icons/send.component';
import { IconMic } from './icons/mic.component';
import { IconMenu } from './icons/menu.component';
import { IconStop } from './icons/stop.component';
import { IconQuestion } from './icons/question.component';

export const UI_KIT_ICONS = [
    {
        provide: HOST_ICON_MAP,
        useValue: new Map<string, any>([
            ['clip', IconClip],
            ['send', IconSend],
            ['mic', IconMic],
            ['menu', IconMenu],
            ['stop', IconStop],
            ['question', IconQuestion],
        ]),
    },
];
